import { Box, Text } from "@chakra-ui/react";

export function EmptyState() {
  return (
    <Box
      marginX="1rem"
      paddingX="2.5rem"
      height="10rem"
      borderRadius="sm"
      boxShadow="md"
      display="flex"
      alignItems="center"
      justifyContent="center"
      background="#FFF"
    >
      <Text textAlign="center" fontSize="1rem">
        Em breve você terá acesso a ofertas exclusivas, pensadas especialmente
        em você!
      </Text>
    </Box>
  );
}
